import { render, staticRenderFns } from "./VideoSingle.vue?vue&type=template&id=244d844a&scoped=true&"
import script from "./VideoSingle.vue?vue&type=script&lang=js&"
export * from "./VideoSingle.vue?vue&type=script&lang=js&"
import style0 from "./VideoSingle.vue?vue&type=style&index=0&id=244d844a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d844a",
  null
  
)

export default component.exports